export const navThemeBasedClass = {
  dark: "bg-dark-purple-50 text-white",
  light: "bg-white text-dark-purple-50",
};

export const loginBtnClassBasedOnTheme = {
  dark: "",
  light:
    "text-dark-purple-50 bg-white border-2 border-dark-purple-50 hover:bg-dark-purple-50 hover:text-white",
};

export const REGIONAL_COUNTRIES = [
  {
    countryCode: "US",
    countryName: "united states of america",
    region: "NA",
    locale: "en-US",
  },
  {
    countryCode: "CA",
    countryName: "canada",
    region: "NA",
    locale: "en-US",
  },
  {
    countryCode: "MX",
    countryName: "mexico",
    region: "NA",
    locale: "en-US",
  },
  {
    countryCode: "BR",
    countryName: "brazil",
    region: "NA",
    locale: "en-US",
  },
  {
    countryCode: "IN",
    countryName: "india",
    region: "APAC",
    locale: "en-IN",
  },
  {
    countryCode: "SG",
    countryName: "singapore",
    region: "APAC",
    locale: "en-IN",
  },
  {
    countryCode: "MY",
    countryName: "malaysia",
    region: "APAC",
    locale: "en-IN",
  },
  {
    countryCode: "FJ",
    countryName: "fiji",
    region: "APAC",
    locale: "en-IN",
  },
  {
    countryCode: "ID",
    countryName: "indonesia",
    region: "APAC",
    locale: "en-IN",
  },
  {
    countryCode: "PH",
    countryName: "philippines",
    region: "APAC",
    locale: "en-IN",
  },
  {
    countryCode: "VN",
    countryName: "viet nam",
    region: "APAC",
    locale: "en-IN",
  },
  {
    countryCode: "AU",
    countryName: "australia",
    region: "ANZ",
    locale: "en-AU",
  },
  {
    countryCode: "NZ",
    countryName: "new zealand",
    region: "ANZ",
    locale: "en-AU",
  },
  {
    countryCode: "GB",
    countryName: "united kingdom of great britain",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "IT",
    countryName: "Italy",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "FR",
    countryName: "france",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "ES",
    countryName: "spain",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "TR",
    countryName: "turkey",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "SA",
    countryName: "saudi arabia",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "AE",
    countryName: "united arab emirates",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "KW",
    countryName: "kuwait",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "IR",
    countryName: "ireland",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "SE",
    countryName: "sweden",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "DK",
    countryName: "denmark",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "FI",
    countryName: "finland",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "DE",
    countryName: "germany",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "CH",
    countryName: "switzerland",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "NL",
    countryName: "netherlands",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "BE",
    countryName: "belgium",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "AT",
    countryName: "austria",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "EG",
    countryName: "egypt",
    region: "EMEA",
    locale: "en-EU",
  },
  {
    countryCode: "OM",
    countryName: "oman",
    region: "EMEA",
    locale: "en-EU",
  },
];

export const LOCALIZED_LOGO_ENABLED_URLS = ["/forrester-wave-q3-2023-report"];
